export enum TransactionCheckPaths {
  ETHEREUM_TRANSACTION = "/ethereum/scan/tx",
  ETHEREUM_TYPED_DATA = "/ethereum/scan/eip-712",
  SOLANA_TRANSACTION = "/solana/scan/tx",
}
